import { useEffect, useState } from "react"
import MobileFormScreen from "../../screen/MobileFormScreen"
import Send from "../../core/communication"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import { useOfflineFormProject } from "../../core/utils/hooks/useFormProject"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { platformDetails } from "../../core/utils/platformDetails"
import { useNavigate } from "react-router-dom"
import { customToast } from "../../components/Toast"
import { useDispatch } from "react-redux"
import { setData } from "../../core/redux/app/Actions"

const MobileFormContainer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userCreated = useUser()
  const { platformLogo } = platformDetails()
  const [selectedProject, setSelectedProject] = useState(null)
  const {
    forms,
    cachedAt,
    selectedFormId,
    setSelectedFormId,
    isLoading,
    reload,
    error
  } = useOfflineFormProject(selectedProject)
  const { projectsByScope } = useScope()
  const { users } = useUsers(selectedProject)
  const [user, setUser] = useState(null)
  const [addBeneficiary, setAddBeneficiary] = useState(false)
  const [search, setSearch] = useState("")

  useEffect(() => {
    if (projectsByScope && projectsByScope.length) {
      const newOptions = projectsByScope.map((row) => ({ value: row.id, label: row.description }))
      setSelectedProject(newOptions[0].value)
    }
  }, [projectsByScope])

  useEffect(() => {
    if (user && selectedFormId && !addBeneficiary) {
      sendDataToGenerateLink()
    }
  }, [user, selectedFormId, addBeneficiary])

  const handleClick = () => {
    console.log({ search })
  }

  const goBack = () => {
    if (selectedFormId && !addBeneficiary) {
      setSearch("")
      setUser(null)
      setSelectedFormId(null)
    } else if (addBeneficiary) {
      setAddBeneficiary(false)
      setSearch("")
      setUser(null)
    }
    else {
      setSearch("")
      setUser(null)
      setSelectedFormId(null)
      navigate(-1)
    }
  }


  const handleSearhTerm = (e) => {
    const { value } = e.target
    setSearch(value)
  }

  const goToAddBeneficiary = () => {
    setAddBeneficiary(true)
  }

  const sendDataToGenerateLink = async () => {
    try {
      if (!user?.id) {
        dispatch(setData({ users: users.concat(user) }))
      }
      setTimeout(() => {
        navigate(`/form_details`, {
          state: {
            formId: selectedFormId,
            userId: (typeof user === "object" && user.id) || false,
            userName: typeof user === "object" && user?.name,
            userCreated: {
              email: userCreated.email,
              id: userCreated.id,
              name: userCreated.name
            },
            phone: typeof user === "object" && user?.phone,
            projectId: selectedProject,
            userForm: user
          },
        })
      }, 1000)
      // const response = await Send.post("/assistance-link", {
      //   farmers: [user],
      //   projectId: selectedProject,
      //   userCreated: userCreated?.id,
      //   formId: selectedFormId,
      //   steps: [], //steps?.map((item) => item?.value),
      //   questions: "",
      // })

      // if (response.status === "Error") throw new Error("Erro ao criar atendimento.")
      // const { data } = response
      // if (data && data.link) {
      //   window.open(data.link + "?callback=conexao", "_self")
      // }
    } catch (error) {
      console.log("Erro ao criar atendimento", error)
      customToast("Erro ao criar atendimento", "error")
    }
  }

  const filteredUsers = () => {
    return Array.isArray(users)
      ? users.filter(
        (user) =>
          user?.name?.toLowerCase().includes(search?.toLowerCase()) ||
          user?.phone?.toLowerCase().includes(search?.toLowerCase()),
      )
      : []
  }

  return (
    <MobileFormScreen
      forms={forms}
      cachedAt={cachedAt}
      users={filteredUsers()}
      form={selectedFormId}
      setForm={setSelectedFormId}
      setUser={setUser}
      user={user}
      handleClick={handleClick}
      platformLogo={platformLogo}
      search={search}
      setSearch={setSearch}
      goBack={goBack}
      goToAddBeneficiary={goToAddBeneficiary}
      addBeneficiary={addBeneficiary}
      handleSearhTerm={handleSearhTerm}
      isLoading={isLoading}
      reload={reload}
      error={error}
      setAddBeneficiary={setAddBeneficiary}
    />
  )
}

export default MobileFormContainer